import { render, staticRenderFns } from "./skipSendExams.view.vue?vue&type=template&id=8d4bd87c&scoped=true"
import script from "./skipSendExams.view.vue?vue&type=script&lang=js"
export * from "./skipSendExams.view.vue?vue&type=script&lang=js"
import style0 from "./skipSendExams.view.vue?vue&type=style&index=0&id=8d4bd87c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4bd87c",
  null
  
)

export default component.exports